<template>
	<div class="d-md-flex flex-column flex-sm-row flex-wrap">
		<div
			class="col-12 col-lg-6 p-0"
			v-for="(ratingObj, ratingObj_i) in starsArr"
			:key="ratingObj_i"
		>
			<div class="d-flex flex-row nowrap my-2">
				<h3 class="body text-grey-900 m-0 text-nowrap pe-3">
					{{ ratingObj.readableName }}
				</h3>
				<div class="star-wrapper d-flex flex-row nowrap align-items-baseline">
					<template v-if="ratingObj.stars.full > 0">
                            <svg
                                v-for="fullStar_i in ratingObj.stars.full"
                                :key="'full-' + fullStar_i"
                                class="icon text-primary-blue"
                                width="13"
                                height="13"
								style="position: relative; top: 1px;"
                                >
								<use href="#___icon___star-full"></use>
                            </svg>
                        </template>

                        <template v-if="ratingObj.stars.half > 0">
                            <svg
                                v-for="halfStar_i in ratingObj.stars.half"
                                :key="'half-' + halfStar_i"
                                class="icon text-primary-blue"
                                width="13"
                                height="13"
								style="position: relative; top: 1px;"
                                >
                                <use href="#___icon___star-half"></use>
                            </svg>
                        </template>

                        <template v-if="ratingObj.stars.empty > 0">
                            <svg
                                v-for="emptyStar_i in ratingObj.stars.empty"
                                :key="'empty-' + emptyStar_i"
                                color="blue"
                                class="icon text-primary-blue"
                                width="13"
                                height="13"
								style="position: relative; top: 1px;"
                                >
                                <use href="#___icon___star-empty"></use>
                            </svg>
                        </template>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState } from "vuex";

export default {
	name: "Summary",
	props: {
		ratings: {
			// array of object, each having the name as key and number as value
			type: Array,
      		default: () => [],
		},
		open: {
			type: Boolean,
			default: false
		},
		maxOpacity: {
			type: Number,
			default: 0.75
		}
	},

	components: {},

	computed: {
		...mapState(["content"]),
		starsArr() {
			return this.ratings
				.map((ratingObj) => {
					const name = ratingObj["name"];
					const rating = ratingObj["rating"];

					return {
						name,
						readableName: this.content[`reviews_ratingTypes_${name}`],
						stars: this.getStarsObj(rating),
					};
				})
				.filter(Boolean)
		},
	},

	methods: {
		getStarsObj(ratingFloat) {
			const full = Math.trunc(ratingFloat);
			const decimalPart = ratingFloat - full;
			const half = decimalPart > 0.33 && decimalPart < 0.67 ? 1 : 0;
			const empty = 5 - full - half;
			return { full, half, empty };
		},
	},

	// mounted() {
	// 	if (this.open) {
	// 		const overlay = this.$refs["overlay"];
	// 		overlay.style.display = "block";
	// 		overlay.style.opacity = this.maxOpacity;
	// 	}
	// },
	
};
</script>

<style scoped>
.overlay {
	transition: opacity 150ms ease-in-out;
}
.overlay {
	position: fixed;
	width: 100%;
	height: 100%;
	z-index: 2000;
	left: 0;
	top: 0;
	background-color: rgba(13, 20, 27, 0.95);
	transition: opacity ease-in-out 250ms;
}

.star-wrapper {
  position: relative;
  top: 5px; /* moves stars downward — adjust as needed */
  display: inline-flex;
  gap: 2px;
}

.star-wrapper .icon {
  display: inline-block;
  vertical-align: middle;
}

</style>
